/**
 * Empty function that does nothing.
 * @returns {undefined}
 */
export const noop = () => undefined;
